const URL = "https://ufoodapi.herokuapp.com";

export const getRestaurantsVisits = async (token) => {

  const response = await fetch(`${URL}/users/${token.id}/restaurants/visits`,  {
    headers: {
      'Authorization': token.token
    },
  })

  return response.json();
}


export const getRestaurantVisits = async (token,Restaurant_ID) => {

  const response = await fetch(`${URL}/users/${token.id}/restaurants/${Restaurant_ID}/visits`, {
    headers: {
      'Authorization': token.token
    },
  })

  return response.json();
}

